import { HeaderBanner } from "@kunduz/ui-components";
import { trackEventNext } from "@kunduz/utility-analytics";
import React, { ReactElement } from "react";

export const HeaderBannerWithContext = (props: Props): ReactElement => {
  const handleOnClickEvent = () => {
    trackEventNext({
      event: "Header Banner Clicked",
      id: props.name,
    });
  };

  return <HeaderBanner {...props} onClick={handleOnClickEvent} />;
};

interface Props {
  url: string;
  label: string;
  buttonLabel: string;
  name?: string;
  isSticky?: boolean;
}
